import {
  Briefcase,
  GraduationCap,
  Dumbbell,
  Smartphone,
  School,
  User,
  Rocket,
  Sparkles,
  ArrowUpRight,
} from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "../config/site";

const ICONS = [Briefcase, GraduationCap, Dumbbell, Smartphone, School, User, Rocket, Sparkles];

export default function Services() {
  return (
    <section
      id="services"
      className="relative scroll-mt-24 border-t border-white/[0.05] bg-[#07080f] py-24 sm:py-28"
      data-testid="services-section"
    >
      <div
        className="pointer-events-none absolute right-0 top-1/3 h-[420px] w-[420px] rounded-full bg-purple-600/[0.08] blur-[130px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="What I Do"
          title={
            <>
              Services Built for <span className="text-gradient">Every Business</span>
            </>
          }
          sub="Professional, AI-powered websites designed, published and delivered for every category of business."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s.title} delay={0.06 * (i % 4)} className="h-full">
                <article
                  className="glass card-hover group relative h-full overflow-hidden rounded-2xl p-6"
                  data-testid={`service-card-${i + 1}`}
                >
                  <div
                    className="pointer-events-none absolute -right-10 -top-10 h-28 w-28 rounded-full bg-indigo-500/10 blur-2xl transition-opacity duration-500 group-hover:bg-purple-500/20"
                    aria-hidden="true"
                  />
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-indigo-400/25 bg-gradient-to-br from-indigo-500/20 to-purple-500/10 text-indigo-300 transition-all duration-500 group-hover:scale-110 group-hover:text-white group-hover:shadow-[0_0_22px_rgba(129,140,248,0.45)]">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-5 font-display text-[17px] font-bold leading-snug text-white">
                    {s.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-400">
                    {s.desc}
                  </p>
                  <a
                    href="#contact"
                    aria-label={`Enquire about ${s.title}`}
                    data-testid={`service-enquire-${i + 1}`}
                    className="mt-5 inline-flex items-center gap-1.5 text-xs font-semibold text-indigo-300 opacity-70 transition-all duration-300 group-hover:gap-2.5 group-hover:opacity-100"
                  >
                    Enquire <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
